import React, { useMemo } from 'react'
import SpecialFormHeaderActions from './SpecialFormHeaderActions'
import { SPECIAL_PRICE_SHOW_DETAIL_SECTION_TITLE } from '../constant/specialPriceViewConstants'
import { buildSpecialPriceDetailRows } from '../helpers/specialPriceShowHelpers'

const renderDetailValue = (item) => {
  if (item.type === 'date_range') {
    return (
      <div className="special-price-show-date-range">
        <span>Inicio: {item.startDate}</span>
        <span>Fin: {item.endDate}</span>
      </div>
    )
  }

  return item.value || '-'
}

const SpecialPriceDetailSection = ({ actions = [], details }) => {
  const detailItems = useMemo(() => buildSpecialPriceDetailRows(details), [details])

  return (
    <div className="task-form-section">
      <div className="special-price-show-section-header">
        <p className="special-price-show-section-title">{SPECIAL_PRICE_SHOW_DETAIL_SECTION_TITLE}</p>
        {actions.length > 0 && (
          <div className="special-price-show-actions">
            <SpecialFormHeaderActions showDivider={false} actions={actions} />
          </div>
        )}
      </div>
      <hr className="mt--5" />

      <div className="special-price-show-details-grid">
        {detailItems.map((item) => (
          <React.Fragment key={item.label}>
            <div className="special-price-show-detail-label">{item.label}:</div>
            <div className="special-price-show-detail-value">{renderDetailValue(item)}</div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default SpecialPriceDetailSection
